<div class="card">
    <app-header titulo="Produção Industrial" descricao="Dados integração da produção industrial"></app-header>

    <p-table [value]="producaos" dataKey="idProd" #dt [loading]="loading"
        [lazy]="true" (onLazyLoad)="carregar($event)" [totalRecords]="totalRecords"
        styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]"
        [paginator]="true" [rows]="rows" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando de {first} até {last} de {totalRecords} registros" [scrollable]="true"
        scrollHeight="40.5rem">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton pRipple icon="pi pi-refresh" (click)="getProducaos()"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="filtro" (input)="buscar()"
                        placeholder="Pesquisar" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="cdEmpresaErp">Empresa (ERP) <p-sortIcon field="cdEmpresaErp" /></th>
                <th pSortableColumn="dtProducao">Data Produção <p-sortIcon field="dtProducao" /></th>
                <th pSortableColumn="cdProdutoErp">Código Produto (ERP) <p-sortIcon field="cdProdutoErp" /></th>
                <th pSortableColumn="varCodigo">Código Variável <p-sortIcon field="varCodigo" /></th>
                <th>Descrição Variável</th>
                <th pSortableColumn="qtProducao">Quantidade Produção <p-sortIcon field="qtProducao" /></th>
                <th>Revertido</th>
                <th pSortableColumn="noDocErp">Número Documento (ERP) <p-sortIcon field="noDocErp" /></th>
                <th pSortableColumn="fgStatusInteg">Integrado <p-sortIcon field="fgStatusInteg" /></th>
                <th>Mensagem</th>
                <th pSortableColumn="dtRecebido">Data Recebido <p-sortIcon field="dtRecebido" /></th>
                <th pSortableColumn="dtIntegErp">Data Integrado <p-sortIcon field="dtIntegErp" /></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-producao>
            <tr>
                <td>{{ producao.cdEmpresaErp }}</td>
                <td>{{ producao.dtProducao | date: 'dd/MM/yyyy' }}</td>
                <td>{{ producao.cdProdutoErp }}</td>
                <td>{{ producao.varCodigo }}</td>
                <td>{{ producao.varDescri }}</td>
                <td>{{ producao.qtProducao }}</td>
                <td>{{ producao.fgRevertido }}</td>
                <td>{{ producao.noDocErp }}</td>
                <td><app-tag-status [status]="producao.fgStatusInteg" ></app-tag-status></td>
                <td>{{ producao.deMensagemInteg }}</td>
                <td>{{ producao.dtRecebido | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ producao.dtIntegErp | date: 'dd/MM/yyyy HH:mm' }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="21">Nenhum registro encontrado</td>
        </ng-template>
    </p-table>
</div>
